<template>
  <tbody class="operative-table--aggregate-table" :class="{ 'aggregate-sticky': sticky }">
    <slot></slot>
  </tbody>
</template>

<script>

export default {
  name: 'operative-table-aggregate-table',
  props: {
    sticky: {
      type: Boolean,
      default: false,
    },
  },
};

</script>

<style lang="scss">

$highlighted-table-font-wieght: 700;
$highlighted-table-background-color: lighten($primary, 47%);
$highlighted-table-border-color: lighten($primary, 35%);

.operative-table--aggregate-table {
  font-weight: $highlighted-table-font-wieght;
  margin-bottom: 1.5rem;

  .operative-table-body-row {
    background: $highlighted-table-background-color !important;
  }

  .operative-table-header-column {
    font-weight: $highlighted-table-font-wieght;
    background: $highlighted-table-background-color !important;
  }

  th, td {
    border-color: $highlighted-table-border-color !important;
  }

  &.aggregate-sticky {
    box-shadow: 0 1px 6px rgba(0,0,0,0.16), 0 1px 6px rgba(0,0,0,0.23);
    display: table-caption; // TODO: check se può andare bene
    left: 0;
    position: sticky;
    top: 0;
    z-index: 12;
    .operative-table-body-row-empty {
      display: none;
    }
  }
}

</style>
